'use strict';
import AssetPaths from '../util/AssetPaths';
import UIAssetsService from './Assets';
const LS_RECENT = 'ath_recent_emojis';
const KEYS = [
    'activity',
    'flags',
    'foods',
    'nature',
    'objects',
    'people',
    'places',
    'symbols',
];
//  PRIVATE
let dict = false;
async function load() {
    if (dict.loaded)
        return;
    let rgx = [];
    const shortcuts = new Map();
    let rgx_shortcuts = [];
    //  Load assets
    for (const key of KEYS) {
        await UIAssetsService.load(`emoji_${key}`).then(data => {
            if (!data)
                return;
            //  Process asset : foreach emoji define symbol/shortcut
            data.list.forEach(emoji => {
                dict.symbols.set(emoji.c, emoji);
                rgx.push(`\\${emoji.c}`);
                //  If shortcut exists, add to map
                if (emoji.hasOwnProperty('s')) {
                    shortcuts.set(emoji.s.replace(/\\/g, ''), emoji.c);
                    rgx_shortcuts.push(`${emoji.s}`);
                }
            });
        });
    }
    //  After-load processing
    //  Build regex to match emoji
    rgx = `(${rgx.join('|')})`;
    rgx_shortcuts = `(${rgx_shortcuts.join('|')})`;
    dict.rgx = new RegExp(rgx, 'g');
    dict.shortcut = {
        map: shortcuts,
        rgx: new RegExp(rgx_shortcuts, 'g'),
    };
}
class UIEmojiService {
    static getInstance() {
        if (!UIEmojiService.instance) {
            UIEmojiService.instance = new UIEmojiService();
        }
        return UIEmojiService.instance;
    }
    constructor() {
        //  Create a new dict store
        dict = {
            loaded: false,
            symbols: new Map(),
            rgx: false,
            shortcut: false,
        };
        return this;
    }
    loadEmojis() {
        //  Register asset packs
        KEYS.forEach(o => UIAssetsService.register(UIAssetsService.tplJSON(`emoji_${o}`, AssetPaths.url(`emoji/${o}.json`)), true));
    }
    get enabled() {
        return window.innerWidth > 1024;
    }
    analyzeText(str) {
        return new Promise(async (resolve) => {
            try {
                //  No need to do analysis when not on desktop
                if (!str || !this.enabled)
                    return resolve({ parsed: str, matched: false });
                await load();
                const rgx_shortcut_matches = str.match(dict.shortcut.rgx);
                //  If shortcuts are apparent, replace them in the string with emoji
                if (rgx_shortcut_matches) {
                    rgx_shortcut_matches.forEach(match => str = str.replace(match, dict.shortcut.map.get(match)));
                }
                return resolve({
                    parsed: str,
                    matched: !!rgx_shortcut_matches,
                });
            }
            catch {
                return resolve();
            }
        });
    }
    patchRecentlyUsed(emoji) {
        let recent = [];
        //  Get recently used emojis from local storage
        if (localStorage.hasOwnProperty(LS_RECENT)) {
            try {
                recent = JSON.parse(localStorage.getItem(LS_RECENT));
            }
            catch {
                //  If fails it fails
            }
        }
        //  Remove emoji if it is already in the recent list
        recent = recent.filter(el => el.c !== emoji.c);
        //  Add emoji at the beginning of the list
        recent.unshift(emoji);
        //  Save last 10 emojis to local storage
        localStorage.setItem(LS_RECENT, JSON.stringify(recent.slice(0, 10)));
    }
    recentEmoji() {
        //  Get recently used emojis from local storage
        let recent = [];
        if (localStorage.hasOwnProperty(LS_RECENT)) {
            try {
                recent = JSON.parse(localStorage.getItem(LS_RECENT));
            }
            catch {
                //  If fails it fails
            }
        }
        return recent;
    }
}
const UIEmoji = UIEmojiService.getInstance();
export { UIEmoji };
export default UIEmoji;
//# sourceMappingURL=Emoji.js.map